<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M2.4 0.5H13.6C14.37 0.5 15 1.11875 15 1.875V10.125C15 10.8813 14.37 11.5 13.6 11.5H2.4C1.63 11.5 1 10.8813 1 10.125V1.875C1 1.11875 1.63 0.5 2.4 0.5Z"
        stroke="#5B6971"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M1.22534 1.77701L8.00004 7.09999L14.7747 1.77701"
        stroke="#5B6971"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
